export const POST_ACCEPT_QUOTATION = 'POST_ACCEPT_QUOTATION';
export const POST_ACCEPT_QUOTATION_PENDING = 'POST_ACCEPT_QUOTATION_PENDING';
export const POST_ACCEPT_QUOTATION_FULFILLED =
  'POST_ACCEPT_QUOTATION_FULFILLED';
export const POST_ACCEPT_QUOTATION_REJECTED = 'POST_ACCEPT_QUOTATION_REJECTED';
